// Dienst-constanten en record-opbouw voor de admin.
// Spiegelt het schema uit between-the-buttons (schemas/service.schema.json)
// zodat wat we hier naar Firestore schrijven geldig is voor de publieke site.

export const CATEGORIES = [
  { value: "muziek-entertainment", label: "Muziek & entertainment" },
  { value: "verhuur", label: "Verhuur" },
  { value: "catering-food", label: "Catering & food" },
  { value: "foto-video", label: "Foto & video" },
  { value: "vervoer", label: "Vervoer" },
  { value: "styling-decoratie", label: "Styling & decoratie" },
  { value: "overige-diensten", label: "Overige diensten" },
];

export const PROVINCES = [
  "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen",
  "Limburg", "Noord-Brabant", "Noord-Holland", "Overijssel",
  "Utrecht", "Zeeland", "Zuid-Holland",
];

export const GESCHIKT_VOOR = ["Bruiloft", "Verjaardag", "Bedrijfsfeest", "Familiedag", "Borrel", "Jubileum", "Themafeest", "Festival", "Kinderfeest"];

// Werkgebied per straal: alternatief voor een provincielijst. De dienst kiest
// een vestigingsplaats (postcode + plaats) en een straal; de publieke site
// matcht diensten waarvan de cirkel de zoeklocatie omvat.
export const REISKOSTEN = ["inbegrepen", "per-km", "op-aanvraag"];
export const STRAAL_OPTIES = [10, 25, 50, 75, 100];

export const PRIJS_MODELLEN = ["vanaf", "per-uur", "per-dag", "per-persoon", "offerte"];
export const SOORT_ACT = ["band", "coverband", "dj", "drive-in-show", "zanger-zangeres", "duo-trio", "kinderentertainment", "act-show", "boekingsbureau"];
export const SOORT_CATERING = ["buffet", "walking-dinner", "bbq", "foodtruck", "hapjes-borrel", "diner", "drankenservice", "bartending"];
export const FOTO_VIDEO_DIENSTEN = ["fotografie", "videografie", "photobooth", "drone", "360-booth", "aftermovie"];
export const STYLING_SPECIALISATIES = ["ballondecoratie", "bloemen", "thema-aankleding", "verlichting-sfeer", "tafelstyling", "backdrops", "letters-verlicht"];
export const VOERTUIG_SOORTEN = ["limousine", "partybus", "oldtimer", "trouwauto", "boot", "koets", "tuktuk", "overig"];

// Bepaalt welk verplicht details-blok bij een categorie hoort. Gebruikt om de
// juiste onboarding-stap te tonen en om het record op te bouwen.
export function detailsForCategory(categorie, values) {
  switch (categorie) {
    case "muziek-entertainment":
      return values.soortAct ? { soortAct: values.soortAct } : null;
    case "verhuur": {
      const assortiment = (values.assortiment || []).map((a) => (a || "").trim()).filter(Boolean).map((naam) => ({ naam }));
      return assortiment.length ? { assortiment } : null;
    }
    case "catering-food":
      return values.soortCatering?.length ? { soortCatering: values.soortCatering } : null;
    case "foto-video":
      return values.diensten?.length ? { diensten: values.diensten } : null;
    case "vervoer": {
      const voertuigen = (values.voertuigen || [])
        .filter((v) => v && v.soort && v.capaciteit)
        .map((v) => ({ soort: v.soort, capaciteit: Number(v.capaciteit) }));
      return voertuigen.length ? { voertuigen } : null;
    }
    case "styling-decoratie":
      return values.specialisaties?.length ? { specialisaties: values.specialisaties } : null;
    case "overige-diensten":
      return values.dienst ? { dienst: values.dienst } : null;
    default:
      return null;
  }
}

// Verwijdert lege waarden zodat optionele blokken niet als lege objecten worden
// weggeschreven.
export function prune(obj) {
  if (Array.isArray(obj)) return obj.map(prune);
  if (obj && typeof obj === "object") {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v === undefined || v === null || v === "") continue;
      const pv = prune(v);
      if (pv && typeof pv === "object" && !Array.isArray(pv) && Object.keys(pv).length === 0) continue;
      out[k] = pv;
    }
    return out;
  }
  return obj;
}
